import { Button } from "@/shared/ui/button";
import { Plus } from "lucide-react";
import { CoreSignalGuideButton } from "../guide/CoreSignalGuideButton";

interface ClassificationRulesPanelHeaderProps {
  rulesCount?: number;
  onCreateClick?: () => void;
}

export function ClassificationRulesPanelHeader({
  rulesCount = 0,
  onCreateClick,
}: ClassificationRulesPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-semibold text-ink-900">
          Classification Rules
        </h2>
        <p className="mt-1 text-sm text-ink-500">
          {rulesCount === 0
            ? "No classification rules"
            : `${rulesCount} ${rulesCount === 1 ? "rule" : "rules"}`}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <CoreSignalGuideButton />
        {onCreateClick && (
          <Button onClick={onCreateClick}>
            <Plus className="mr-2 h-4 w-4" />
            Create rule
          </Button>
        )}
      </div>
    </div>
  );
}
